import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { QueueViewComponent } from './queue-view.component';
import { LoadingModule } from 'shared/components/loading/loading.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { QueueViewTabModule } from './queue-view-tab/queue-view-tab.module';
import { TooltipModule } from 'shared/components/tooltip/tooltip.module';
import { WorkitemActivityIndicatorModule } from '../../shared/components/workitem-activity-indicator/workitem-activity-indicator.module';
import { QueueViewNotificationsService } from './queue-view-notifications.service';
import { LiveWorkloadTabModule } from 'components/queue-view/live-workload-tab/live-workload-tab.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SvgIconModule,
    FormsModule,
    LoadingModule,
    MatCheckboxModule,
    MatSelectModule,
    QueueViewTabModule,
    TooltipModule,
    WorkitemActivityIndicatorModule,
    LiveWorkloadTabModule
  ],
  declarations: [
    QueueViewComponent
  ],
  exports: [
    QueueViewComponent
  ],
  providers: [
    QueueViewNotificationsService
  ]
})
export class QueueViewModule {}
